import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';

import { AuthUser } from '@monorepo/ui/auth';
import { Booking, BookingStatus } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ApprovalsService {
  authUserUid: string;

  constructor(private afs: AngularFirestore, private afAuth: AngularFireAuth) {
    this.afAuth.authState.subscribe(
      (authUser: AuthUser) => {
        if (authUser) {
          this.authUserUid = authUser.uid;
        }
      },
      () => {
        this.authUserUid = null;
      }
    );
  }

  public getApprovalRequests(isAdmin: boolean): Observable<any[]> {
    if (isAdmin) {
      return this.afs
        .collection(`/bookings`, (ref) =>
          ref.where('status', '==', BookingStatus.IN_REVIEW)
        )
        .valueChanges();
    } else {
      return this.afs
        .collection(`/bookings`, (ref) =>
          ref
            .where('ownerId', '==', this.authUserUid)
            .where('status', '==', BookingStatus.ADMIN_APPROVED)
        )
        .valueChanges();
    }
  }

  public updateBooking(booking: Booking): Promise<void> {
    return this.afs.doc(`/bookings/${booking.id}`).update({ ...booking });
  }
}
